import GenericDB from './generic-db';

export default class AssessmentsDB extends GenericDB {
  constructor() {
    super('assessments');
  }
}
